import { render, staticRenderFns } from "./ProductDetailsGallery.vue?vue&type=template&id=4df254a0"
import script from "./ProductDetailsGallery.vue?vue&type=script&lang=js"
export * from "./ProductDetailsGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports